import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage, FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import { Fragment } from 'react';
import Big from 'UIComponents/elements/Big';
import styled from 'styled-components';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import H1 from 'UIComponents/elements/headings/H1';
import H5 from 'UIComponents/elements/headings/H5';
import { useWizardProgress } from '../../features/wizard';
const SubTitleParagraph = styled.p.withConfig({
  displayName: "WizardTitle__SubTitleParagraph",
  componentId: "sc-1ptxram-0"
})(["max-width:470px;&.text-center{padding:0 10px;}"]);
const ResponsiveH1 = styled(H1).withConfig({
  displayName: "WizardTitle__ResponsiveH1",
  componentId: "sc-1ptxram-1"
})(["margin-bottom:5px;@media (max-width:", "){width:70%;margin:10px auto 15px;font-size:20px;}"], GRID_BREAKPOINT_SMALL);
const TitleH5 = styled(H5).withConfig({
  displayName: "WizardTitle__TitleH5",
  componentId: "sc-1ptxram-2"
})(["text-align:left;margin-bottom:2px;"]);

const WizardTitle = ({
  isMobile,
  catGroup
}) => {
  const {
    currentStep
  } = useWizardProgress();

  const getTitleText = () => {
    return currentStep === 'category' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.wizard.modal.stepcategory.title",
      options: {
        categoryGroup: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.filtersGroups.${catGroup}`
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.wizard.modal.step${currentStep}.title`
    });
  };

  const getSubTitleText = () => {
    return currentStep === 'initial' && /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.wizard.modal.stepinitial.subtitle`
    });
  };

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!isMobile ? /*#__PURE__*/_jsx(ResponsiveH1, {
      className: isMobile ? 'text-center' : '',
      children: getTitleText()
    }) : /*#__PURE__*/_jsx(TitleH5, {
      children: getTitleText()
    }), /*#__PURE__*/_jsxs(SubTitleParagraph, {
      className: isMobile ? 'text-left' : '',
      children: [!isMobile && /*#__PURE__*/_jsx(Big, {
        children: getSubTitleText()
      }), isMobile && getSubTitleText()]
    })]
  });
};

export default WizardTitle;